/**
 * Profile - Modern profile system
 *
 * Export main profile components
 */

export { default as CandidateProfile } from './CandidateProfile'
export { default as EmployerProfile } from './EmployerProfile'

// Default export for viewing other users' profiles
// TODO: Implement proper public profile view component
import React from 'react'
import { Box, Typography } from '@mui/material'

export default function UserProfile() {
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Profile View
      </Typography>
      <Typography color="text.secondary">
        Public profile view coming soon
      </Typography>
    </Box>
  )
}
